import { render } from "./Hotspot27.vue?vue&type=template&id=faa84796&scoped=true&ts=true"
import script from "./Hotspot27.vue?vue&type=script&lang=ts"
export * from "./Hotspot27.vue?vue&type=script&lang=ts"

import "./Hotspot27.vue?vue&type=style&index=0&id=faa84796&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa84796"]])

export default __exports__